export const SERVICES_IN_SERP_FEATURE_FLAG = 'services_in_serp';
export const SWISH_GC_CHECKOUT_FEATURE_FLAG = 'swish_gc_checkout';
export const QLIRO_GC_CHECKOUT_FEATURE_FLAG = 'qliro_gc_checkout';
export const DEALS_FEATURE_FLAG = 'deals_smoke_test';
export const NEW_PLACE_EXPERIMENT = 'new-place-page';
export const MEGA_MENU_NAVIGATION_FEATURE_FLAG = 'megamenu_navigation';
export const CHECKOUT_REDESIGN_FEATURE_FLAG = 'checkout_redesign';
